import { address as mezoMainnetAddress } from "@mezo-org/mezod-contracts/deployments/mainnet/mUSDe.json"
import { address as mezoTestnetAddress } from "@mezo-org/mezod-contracts/deployments/testnet/mUSDe.json"
import { Address } from "viem"

import artifacts from "#/shared/utils/artifacts"

export default artifacts.getBridgeableERC20TokenArtifact({
  mainnetAddress: "0x4c9EDD5852cd905f086C759E8383e09bff1E68B3",
  testnetAddress: "0x07FcF6368d34D430aAFDc64435517842775fbF1B",
  mezoTestnetAddress: mezoTestnetAddress as Address,
  mezoMainnetAddress: mezoMainnetAddress as Address,
})
